import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';

const noop = () => { };

export const CUSTOM_DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => FormDropdownV2Component),
	multi: true
};

@Component({
	selector: 'fm-dropdown-v2',
	templateUrl: 'form-dropdown.component.html',
	styleUrls: ['form-dropdown.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [CUSTOM_DROPDOWN_CONTROL_VALUE_ACCESSOR],
})
export class FormDropdownV2Component extends BaseErrorForm
	implements ControlValueAccessor, OnInit, OnDestroy {
	[x: string]: any;
	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		public formEventService: FormEventService
	) {
		super();
	}

	options: Array<{}>;

	// Placeholders for the callbacks which are later provided
	// by the Control Value Accessor
	@Input() styleClass: string;
	@Input() lazy: boolean = false;
	@Input() filter: boolean = false;
	@Input() disabled: boolean = false;
	@Input() sortable: boolean = true;
	@Input() appendTo = "body";
	@Input() scrollHeight: string = "180px";
	@Input() placeholder: string = "Select Type";
	@Input() title: string;
	@Input() titlePosition: string = "";
	@Output() onChanged: EventEmitter<any> = new EventEmitter<any>();

	@Input('options')
	set opts(val: Array<object>) {
		this.options = val;
	}

	tabindex: string;
	@Input('tabindex')
	set tabin(val: string) {
		this.tabindex = String(val);
	}

	private innerValue: any = '';
	private onTouchedCallback: () => void = noop;
	private onChangeCallback: (_: any) => void = noop;

	ngOnInit() {
		this.formEventService.setIndex(parseInt(this.tabindex));
	}

	ngOnDestroy(): void { }

	get value(): any {
		return this.innerValue;
	}

	// set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v;
			this.onChangeCallback(v);
		}
	}

	onClick(event: any) {
	}

	// Set touched on blur
	onBlur() {
		this.onTouchedCallback();
	}

	onChange(obj: { originalEvent: Event; value: string }) {
		if (obj.value !== this.innerValue) {
			this.writeValue(obj.value);
		}
		this.onChanged.emit(obj.value);
	}

	onFocus(event: Event) {
		this.onTouchedCallback();
	}

	// From ControlValueAccessor interface
	writeValue(value: any) {
		if (value !== this.innerValue) {
			this.innerValue = value;
		}
	}

	// From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	// From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}

	getOptionsLen(): boolean {
		if (this.options) {
			if (this.options.length == 0) {
				return true;
			}
			else {
				return false;
			}
		}
	}
}
